import React from 'react';
import config from '../../config';

export default function Footer() {
  return (
    <footer id="footer">
      <ul className="icons">
        {config.socialLinks.map(social => {
          const { icon, name, url } = social;
          return (
            <li key={name}>
              <a rel="nofollow" href={url} title={name} className="icon">
                <i className={icon}></i>
              </a>
            </li>
          );
        })}
      </ul>
    </footer>
  );
}
